import { t } from '@lingui/core/macro';

/**
 * Validator for optional URL text inputs used with react-hook-form's `validate`.
 * Returns `true` when valid (or empty), or a translated error message otherwise.
 */
export function validateUrlField(value: string | null | undefined): true | string {
  const trimmed = value?.trim();

  if (!trimmed) {
    return true;
  }

  if (/\s/.test(trimmed)) {
    return t`URL should not contain spaces`;
  }

  try {
    const url = new URL(trimmed);

    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return true;
    }

    return t`URL must start with http:// or https://`;
  } catch {
    return t`Please enter a valid URL`;
  }
}
